export function LogoMark({ className = "w-7 h-7" }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 200 200"
      fill="none"
      aria-hidden="true"
    >
      <rect width="200" height="200" rx="48" fill="#10b981" />
      {/* Document pages */}
      <rect x="52" y="36" width="80" height="104" rx="8" fill="white" opacity="0.35" />
      <rect x="60" y="44" width="80" height="104" rx="8" fill="white" opacity="0.7" />
      <rect x="68" y="52" width="80" height="104" rx="8" fill="white" />
      {/* Text lines */}
      <rect x="80" y="70" width="48" height="5" rx="2.5" fill="#10b981" opacity="0.5" />
      <rect x="80" y="82" width="40" height="5" rx="2.5" fill="#10b981" opacity="0.35" />
      <rect x="80" y="94" width="52" height="5" rx="2.5" fill="#10b981" opacity="0.35" />
      <rect x="80" y="106" width="32" height="5" rx="2.5" fill="#10b981" opacity="0.35" />
      {/* Cursor arrow */}
      <path
        d="M118 120 L118 156 L128 146 L138 162 L144 158 L134 142 L146 140 Z"
        fill="white"
        stroke="#10b981"
        strokeWidth="3"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function Logo({ className = "" }: { className?: string }) {
  return (
    <a href="/" className={`flex items-center gap-2 group ${className}`}>
      <LogoMark />
      <span className="font-display font-bold text-slate-900 text-lg tracking-tight">
        Instruo
      </span>
    </a>
  )
}
